(function() {
  const BREAK_POINT = 1024;

  const $htmlContainer = $('html');
  const $headerContainer = $('.header');
  const $main = $('.site__main');
  const $toggleMobileNavigation = $('.js_toggle-mobile-nav'); // ハンバーガーメニューの開閉ボタン
  const $navigationContainer = $('.js_nav-container'); // モバイルナビのコンテナ
  const $submenuTrigger = $('.js_header-submenu-trigger'); // お役立ち情報のトリガー
  const $submenuContainer = $('.js_header-submenu-container'); // お役立ち情報（ブログサブメニュー）のコンテナ
  const $submenuBody = $('.js_header-submenu-body');
  const $modalBackground = $('.js_modal-background');

  let scrollY = 0;

  // 背景スクロール固定
  const lockScroll = () => {
    scrollY = window.scrollY;
    $htmlContainer.addClass('is-overflow-hidden').css('top', -scrollY + 'px');
  };

  // 背景スクロール解除
  const unlockScroll = () => {
    $htmlContainer.removeClass('is-overflow-hidden').css('top', '');
    window.scrollTo(0, scrollY);
  };

  // グローバルナビゲーション（モバイルナビ）を閉じる関数
  const closeGlobalNavigation = (setFocusToToggle = true) => {
    if ($(window).width() <= BREAK_POINT && $headerContainer.hasClass('-mobile-nav-open')) {
      unlockScroll();
      $toggleMobileNavigation.attr('aria-expanded', 'false');
      $main.attr('aria-hidden', 'false');
      $headerContainer.removeClass('-mobile-nav-open');
      if (setFocusToToggle) {
        $toggleMobileNavigation.focus(); // 閉じた後にトグルボタンにフォーカスを戻す
      }
    }
  };

  // ブログサブメニューのトグルスイッチ
  const toggleSubmenu = () => {
    const isOpen = $submenuContainer.hasClass('is_open');
    $submenuContainer.toggleClass('is_open', !isOpen);
    $htmlContainer.toggleClass('is-overflow-hidden', !isOpen);
    $submenuTrigger.attr('aria-expanded', !isOpen);

    $main.attr('aria-hidden', !isOpen);
    if (!isOpen) {
      $modalBackground.fadeIn(0);
      // サブメニューが開いた時に、内部の最初の要素にフォーカスを移動
      const $firstFocusable = $submenuContainer.find(focusableSelectors).first();
      if ($firstFocusable.length) { // 要素が存在するかチェック
        $firstFocusable.focus();
      }
    } else {
      $modalBackground.fadeOut(0);
      $submenuTrigger.focus(); // 閉じた時にトリガーにフォーカスを戻す
    }
  };

  // ブログサブメニューの初期化
  const initializeSubmenu = () => {
    $submenuContainer.removeClass('is_open');
    $htmlContainer.removeClass('is-overflow-hidden');
    $submenuTrigger.attr('aria-expanded', 'false');
    $main.attr('aria-hidden', 'false');
    $modalBackground.fadeOut(0);
  };

  // モバイル幅表示のセットアップ
  const setupMobileView = () => {
    initializeSubmenu(); // デスクトップ用サブメニューを閉じる
    closeGlobalNavigation(false); // モバイルナビを閉じる（フォーカスは戻さない）
    $toggleMobileNavigation.attr({
      'aria-controls': 'global-navigation-menu',
      'aria-expanded': 'false'
    });
    $navigationContainer.attr({
      'role': 'dialog',
      'id': 'global-navigation-menu',
      'aria-modal': 'true',
      'aria-labelledby': "js-global-navigation-label"
    });
    $submenuBody.removeAttr('role aria-modal aria-labelledby');
  };

  // デスクトップ幅表示のセットアップ
  const setupDesktopView = () => {
    initializeSubmenu(); // デスクトップ用サブメニューを閉じる
    closeGlobalNavigation(false); // モバイルナビを閉じる（フォーカスは戻さない）
    $toggleMobileNavigation.removeAttr('aria-controls aria-expanded');
    $navigationContainer.removeAttr('role id aria-modal aria-labelledby');
    $submenuBody.attr({
      'role': 'dialog',
      'aria-modal': 'true',
      'aria-labelledby': "js-header-submenu-label"
    });
  };

  // ハンバーガーメニューのクリックイベント
  $toggleMobileNavigation.on('click', () => {
    const isOpen = $headerContainer.hasClass('-mobile-nav-open');
    if (!isOpen) {
      lockScroll();
      const $firstFocusable = $navigationContainer.find(focusableSelectors).first();
      if ($firstFocusable.length) {
          $firstFocusable.focus();
      }
    } else {
      unlockScroll();
    }
    $toggleMobileNavigation.attr('aria-expanded', !isOpen);
    $main.attr('aria-hidden', !isOpen);
    $headerContainer.toggleClass('-mobile-nav-open');
    handleMobileNavFocusTrap(); // メニューが開いた後にフォーカストラップを再設定する
  });

  // ロード時およびリサイズ時の初期セットアップ
  $(window).on('load resize', (() => {
    let lastWindowWidth = $(window).width();

    return () => {
      const currentWindowWidth = $(window).width();
      if ((lastWindowWidth <= BREAK_POINT && currentWindowWidth > BREAK_POINT) || (lastWindowWidth > BREAK_POINT && currentWindowWidth <= BREAK_POINT)) {
        if (currentWindowWidth <= BREAK_POINT) {
          setupMobileView();
        } else {
          setupDesktopView();
        }
      }
      lastWindowWidth = currentWindowWidth;
    };
  })());

  // サブメニューのクリックイベント
  $submenuTrigger.on('click', toggleSubmenu);
  $modalBackground.on('click', () => {
    if ($submenuContainer.hasClass('is_open')) {
        toggleSubmenu();
    }
    if ($headerContainer.hasClass('-mobile-nav-open')) {
        closeGlobalNavigation(true);
    }
  });

  // フォーカス可能な要素のセレクタを定義
  const focusableSelectors = [
    'a[href]:not([disabled]):not([tabindex="-1"])',
    'button:not([disabled]):not([tabindex="-1"])',
    'textarea:not([disabled]):not([tabindex="-1"])',
    'input[type="text"]:not([disabled]):not([tabindex="-1"])',
    'input[type="radio"]:not([disabled]):not([tabindex="-1"])',
    'input[type="checkbox"]:not([disabled]):not([tabindex="-1"])',
    'input[type="search"]:not([disabled]):not([tabindex="-1"])',
    'select:not([disabled]):not([tabindex="-1"])'
  ].join(', ');

  // SP時はグローバルナビゲーションをフォーカストラップにする
  const handleMobileNavFocusTrap = () => {
    if ($(window).width() <= BREAK_POINT && $headerContainer.hasClass('-mobile-nav-open')) {
      const $allFocusableElements = $navigationContainer.find(focusableSelectors).add($toggleMobileNavigation);
      const $firstFocusableElement = $allFocusableElements.first();
      const $lastFocusableElement = $allFocusableElements.last();

      $allFocusableElements.off('.focusTrap'); // 重複登録防止

      $lastFocusableElement.on('blur.focusTrap', () => {
        setTimeout(() => {
            if (!document.activeElement || !($navigationContainer[0].contains(document.activeElement) || $toggleMobileNavigation[0] === document.activeElement)) {
                $firstFocusableElement.focus();
            }
        }, 0);
      });

      $firstFocusableElement.on('keydown.focusTrap', (e) => {
        if (e.key === 'Tab' && e.shiftKey) {
          e.preventDefault();
          $lastFocusableElement.focus();
        }
      });
    } else {
        $navigationContainer.find(focusableSelectors).off('.focusTrap');
        $toggleMobileNavigation.off('.focusTrap');
    }
  };

  $submenuContainer.on('focusout', function(e) {
    if ($submenuContainer.hasClass('is_open')) {
      if (!this.contains(e.relatedTarget) && $submenuTrigger[0] !== e.relatedTarget) {
        toggleSubmenu(); // サブメニューを閉じる
      }
    }
  });


  // ESCキーでモーダルダイアログを抜ける
  $(document).on('keyup', (e) => {
    if (e.key === 'Escape') {
      if ($(window).width() <= BREAK_POINT && $headerContainer.hasClass('-mobile-nav-open')) {
        closeGlobalNavigation(true);
      } else if ($submenuContainer.hasClass('is_open')) { // 幅判定なしで、開いていれば閉じる
        toggleSubmenu();
      }
    }
  });
}());
